import { DAIMI_CN_INTRO, DAIMI_CN_SLUG } from '@/content/daimiConstruction'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The ninth report with a designed page of its own, and the fifth whose own
  // copy was supplied rather than paraphrased — asked for on 2026-08-27
  // (*"construction focus"*) with four attachments: a full-page screenshot of
  // the live page, the cover at 2560px, Figure 1 and the report mockup. See
  // `content/daimiConstruction.ts` and `pages/DaimiConstruction.tsx`.
  ...focus(
    DAIMI_CN_SLUG,
    'Construction',
    'daimi-report-2026-construction-cover',
    'fec3ca78-0ef9-4a93-87f1-5b2446922e6f-digitopia-daimi-2026-report-construction.pdf',
  ),
  // The sector's own paragraphs, transcribed from the reference screenshot and
  // held on the page that says them — so the search result and the page cannot
  // drift apart. `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_CN_INTRO.body,
  layout: 'construction-focus',
  // Its own words, its cover, its file and both of its figures, so `stillToCome`
  // has nothing left to say about it. What is still open is section-by-section
  // on its page, and `daimiConstructionChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 7
